import { slugify } from '@djgg/creations';

/** These mirror the ordinary `uploadAssets` PNG contract. */
export const VISUAL_UPLOAD_KINDS = ['sprite', 'background', 'icon', 'palette', 'cover'] as const;
export const MAX_VISUAL_UPLOAD_FILES = 8;
export const MAX_VISUAL_UPLOAD_BYTES = 2 * 1024 * 1024;

export type VisualUploadKind = (typeof VISUAL_UPLOAD_KINDS)[number];

export function isPngUpload(file: File): boolean {
  return file.type === 'image/png' || file.name.toLowerCase().endsWith('.png');
}

/** The callable receives bare base64, never a data-URL prefix. */
export async function visualFileToBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  const chunk = 0x8000;
  for (let index = 0; index < bytes.length; index += chunk) {
    binary += String.fromCharCode(...bytes.subarray(index, index + chunk));
  }
  return btoa(binary);
}

export function visualUploadName(file: File): string {
  return slugify(file.name.replace(/\.png$/i, ''));
}
